/**
 * The shared environment variables between all configurations.
 * Configurations can overwrite any of these variables in their own configuration file.
 * Don't forget to call injectEndpoints for each specific configuration,
 * otherwise no endpoints will be available in that configuration!
 */
function getEndpoints(api:string) {
    return {
        login: `${api}login/`,
        tokenlogin: `${api}tokenlogin/`,
        forgotpassword: `${api}users/password/`,
        resetpassword: `${api}password-reset/`,
        check_token: `${api}check_token/`,
        users: `${api}users/`,
        groups: `${api}groups/`,
        verify: `verify/`,
        protocols: `${api}protocols/`,
        protocol_metadata: `metadata/`,
        protocol_flow: `flow/`,
        tags: `${api}tags/`,
        actions: `${api}actions/`,
        questions: `${api}flowquestions/`,
        question_suggestion: `${api}flowquestions/suggest/`,
        categories: `${api}categories/`,
        calls: `${api}calls/`,
        call_situation: `situation/`,
        call_vitals: `vitals/`,
        call_tags_suggestion: `tags/suggestions/`,
        call_protocols_suggestion: `protocols/suggestions/`,
        answers: `answers/`,
        history: `history/`,
        select: `select/`,
        centres: `${api}centres/`,
        action_select: `action_select/`,
        related: `related/`,
        logging: `${api}logging/`,
        home: `home/`,
        centreButton: `${api}centre-button/`,
    };
}

export const environment = {
    production: false,

    locales: {
        nl: 'Nederlands',
        fr: 'Français',
    },
    default_locale: 'nl',
    actionLevelClasses: [
        'text-danger',
        'text-warning',
        undefined,
        'text-success',
        'text-primary',
        'text-secondary',
    ],
    protocol_reference_level: 99,

    // The api endpoints
    api: undefined,
    endpoints: getEndpoints(''), // This is only here so typescript can find the endpoint types without us having to repeat them

    // Sentry
    sentryEnabled: false,
    sentryDSN: 'https://eb407ba68c14361de2a7597fd5980f3f@o4506185936797696.ingest.sentry.io/4506581289336832',
    sentryTracesSampleRate: 0.6,
    sentryEnvironment: 'development',
    replaysSessionSampleRate: 1,
};

// Inject the API endpoints for the environment's api host
export function injectEndpoints(env:any) {
    env.endpoints = getEndpoints(env.api);
}

// Update the version string to reflect the current environment
export function injectEnvironment(env:any, stage: string) {
    env.version = `${env.version}.${stage}`;
}
